const BASE_URL = 'http://re_bag.onbotics.cn'; //正式环境
// const BASE_URL = 'http://192.168.176.10:9001'; //开发环境

import request from './request.js';

export default {
	BASE_URL: BASE_URL,
	//获取日程信息
	getSchedule(data) {
		return request(BASE_URL + '/suda/getSchedule', 'get', data);
	},
	//查询用户修改的日程
	getRepresentation(data) {
		return request(BASE_URL + '/suda/getRepresentation', 'get', data);
	},
	//新建日程
	setSchedule(data) {
		return request(BASE_URL + '/suda/setSchedule', 'post', data);
	},
	//管理员修改总日程
	updateSchedule(data) {
		return request(BASE_URL + '/suda/updateSchedule', 'post', data);
	},
	//用户修改日程
	setRepresentation(data) {
		return request(BASE_URL + '/suda/setRepresentation', 'post', data);
	},
	//用户删除日程
	deleteRepresentation(data) {
		return request(BASE_URL + '/suda/deleteRepresentation', 'post', data);
	},
	//管理员删除总日程
	deleteSchedule(data) {
		return request(BASE_URL + '/suda/deleteSchedule', 'post', data);
	},
	//获取当前用户服务人员信息
	getServicePersonInfo(data) {
		return request(BASE_URL + '/suda/getServicePersonInfo', 'get', data);
	},
	//获取用户信息
	getUserInfo(data) {
		return request(BASE_URL + '/suda/getUserInfo', 'get', data);
	},
	//获取日程变更通知
	getContentOperateLogView(data) {
		return request(BASE_URL + '/suda/getContentOperateLogView', 'get', data);
	},
	//获取列表形式日程信息
	getScheduleWithPage(data) {
		return request(BASE_URL + '/suda/getScheduleWithPage', 'get', data);
	},
	//搜索日程
	searchSchedule(data) {
		return request(BASE_URL + '/suda/searchSchedule', 'get', data);
	},
	//下载上传的文件
	getFile(data) {
		return request(BASE_URL + '/suda/getFile', 'download', data);
	},
	//获取所有用户权限
	getAllRoles() {
		return request(BASE_URL + '/suda/getAllRoles', 'get');
	},
	//用户管理-新增
	addUser(data) {
		return request(BASE_URL + '/suda/addUser', 'post', data);
	},
	//用户管理-编辑
	updateUser(data) {
		return request(BASE_URL + '/suda/updateUser', 'post', data);
	},
	//用户管理-删除
	deleteUser(data) {
		return request(BASE_URL + '/suda/deleteUser', 'post', data);
	},
	//用户管理-查询校领导
	getLeaders(data) {
		return request(BASE_URL + '/suda/getLeaders', 'get', data);
	},
	//用户管理-查询联络员
	getLiaisons(data) {
		return request(BASE_URL + '/suda/getLiaisons', 'get', data);
	},
	//用户管理-查询所有用户
	getAllUsers(data) {
		return request(BASE_URL + '/suda/getAllUsers', 'get', data);
	},
	//登录
	login(data) {
		return request(BASE_URL + '/suda/login', 'get', data);
	},
	//查询我创建的日程
	getScheduleSignal(data) {
		return request(BASE_URL + '/suda/getScheduleSignal', 'get', data);
	},
	//查询我创建的日程——列表
	getScheduleWithPageAndScheduleUserId(data) {
		return request(BASE_URL + '/suda/getScheduleWithPageAndScheduleUserId', 'get', data);
	},
}